
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThankYouText } from './components/ThankYouText';

function ThankYou() {
  return (
    <div className="App">
      <ThankYouText />      
      </div>
  );
}

export default ThankYou;
